module.exports = __webpack_public_path__ + "img/h6.06d38110.png";